import React from "react";

export const NavItemExternalLink = ({title, href}) => (
    <a
        target="_blank"
        rel="noopener noreferrer"
        className='nav-list__item'
        href={href}>
        <span className="nav-list__item-name">
            <span className="glyphicon glyphicon-link"/>{' ' + title}</span>
    </a>
);

export default NavItemExternalLink